module.exports = __webpack_public_path__ + "static/media/covid-iq800w.4c6f4ba7.webp";